package it.neckar.lizergy.model

import it.neckar.lizergy.model.assemblyPortfolio.ResolvedAssemblyPortfolio
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.company.PlannerCompanyInformation
import it.neckar.lizergy.model.company.user.UserInformation
import it.neckar.lizergy.model.configuration.ResolvedPhotovoltaicsConfiguration
import it.neckar.lizergy.model.configuration.quote.QuoteConfigurations
import it.neckar.lizergy.model.configuration.quote.QuoteSnapshot
import it.neckar.lizergy.model.configuration.quote.evaluate
import it.neckar.lizergy.model.customer.Customer
import it.neckar.lizergy.model.customer.Example
import it.neckar.lizergy.model.price.AvailableProducts
import it.neckar.lizergy.model.price.PriceList
import it.neckar.lizergy.model.price.StaticPriceList
import it.neckar.lizergy.model.price.lizergy.LizergyPriceListFactory
import it.neckar.lizergy.model.project.ArchiveReasons
import it.neckar.lizergy.model.project.ResolvedBlueprint
import it.neckar.lizergy.model.project.ResolvedProject
import it.neckar.lizergy.model.stumps.AdvanceInvoice
import it.neckar.lizergy.model.stumps.AssemblyBasement
import it.neckar.lizergy.model.stumps.AssemblyRoof
import it.neckar.lizergy.model.stumps.Documentation
import it.neckar.lizergy.model.stumps.FinalAccount
import it.neckar.lizergy.model.stumps.FinishingUp
import it.neckar.lizergy.model.stumps.GridAssessment
import it.neckar.lizergy.model.stumps.OrderSpecialMaterial
import it.neckar.lizergy.model.stumps.StartupOperations
import it.neckar.lizergy.model.stumps.SwitchMeterBox
import it.neckar.open.time.nowMillis
import it.neckar.uuid.randomForEnvironment
import kotlin.uuid.Uuid

/**
 * creates Demo Projects for Testing
 * see [DemoDataFactory]
 */
object DemoProjectFactory {

  private val staticPriceList: StaticPriceList = LizergyPriceListFactory.createPriceList()

  fun createDemoProject(
    resolvedConfigurations: List<ResolvedPhotovoltaicsConfiguration> = listOf(DemoDataFactory.createConfiguration(creationTime = nowMillis())),
    availableProducts: AvailableProducts,
    priceList: PriceList = staticPriceList,
    projectName: String = "",
    projectDescription: String = "",
    customer: Customer = Customer.Example.PeterMüller,
    maintainer: UserInformation,
    blueprint: ResolvedBlueprint,
    currentQuoteSnapshot: QuoteSnapshot? = null,
  ): ResolvedProject {

    val quoteConfigurationsList = resolvedConfigurations.map {
      it.evaluate(
        currentQuoteSnapshot = currentQuoteSnapshot,
        availableProducts = availableProducts,
        priceList = priceList
      )
    }
    val quoteConfigurations = QuoteConfigurations(quoteConfigurationsList)


    return ResolvedProject(
      projectId = blueprint.projectId,
      projectName = projectName,
      projectDescription = projectDescription,
      sellingCompanyInformation = PlannerCompanyInformation.createDemoCompany(CompanyCode.DemoCompany),
      customer = customer,
      maintainerInformation = maintainer,
      blueprint = blueprint,
      quoteConfigurations = quoteConfigurations,
      orderSpecialMaterial = OrderSpecialMaterial(Uuid.randomForEnvironment(), blueprint.projectId),
      gridAssessment = GridAssessment(Uuid.randomForEnvironment(), blueprint.projectId),
      assemblyPortfolio = ResolvedAssemblyPortfolio.getEmpty(blueprint.projectId, Uuid.randomForEnvironment()),
      advanceInvoice = AdvanceInvoice(Uuid.randomForEnvironment(), blueprint.projectId),
      assemblyRoof = AssemblyRoof(Uuid.randomForEnvironment(), blueprint.projectId),
      assemblyBasement = AssemblyBasement(Uuid.randomForEnvironment(), blueprint.projectId),
      switchMeterBox = SwitchMeterBox(Uuid.randomForEnvironment(), blueprint.projectId),
      startupOperations = StartupOperations(Uuid.randomForEnvironment(), blueprint.projectId),
      finishingUp = FinishingUp(Uuid.randomForEnvironment(), blueprint.projectId),
      finalAccount = FinalAccount(Uuid.randomForEnvironment(), blueprint.projectId),
      documentation = Documentation(Uuid.randomForEnvironment(), blueprint.projectId),
      verification = null,
      archiveReasons = ArchiveReasons.getEmpty(),
      creationTime = nowMillis(),
    )
  }
}
